import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=5f8248b1"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports